export const tableList = [
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622014-SHDR-D010000001",
        "add_time": "2022-06-22 17:33:53",
        "platform_trade_id": "22062204140030001070",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "",
        "out_time": "",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622014-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691428937413",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "",
                "refund_time": "",
                "psp_name": "ali"
            },
            // {
            //     "transaction_id": "20220622014-SHDR-D010000001-WECHAT",
            //     "psp_order_id": "4200001493202206228312088439",
            //     "transaction_status": "SUCCESS",
            //     "finish_time": "",
            //     "refund_status": "",
            //     "refund_time": "",
            //     "psp_name": "wechat"
            // }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622012-SHDR-D010000001",
        "add_time": "2022-06-22 17:26:58",
        "platform_trade_id": "22062204140030001068",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "",
        "out_time": "",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622012-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691428993789",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-22 17:28:48",
                "psp_name": "ali"
            },
            {
                "transaction_id": "20220622012-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001467202206227178520127",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-23 10:59:33",
                "psp_name": "wechat"
            },
            {
                "transaction_id": "20220622014-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001493202206228312088439",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "",
                "refund_time": "",
                "psp_name": "wechat"
            }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622011-SHDR-D010000001",
        "add_time": "2022-06-22 16:03:46",
        "platform_trade_id": "22062204140030001067",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "",
        "out_time": "",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622011-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691429054422",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-22 16:41:55",
                "psp_name": "ali"
            },
            {
                "transaction_id": "20220622011-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001470202206224009358431",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "",
                "refund_time": "",
                "psp_name": "wechat"
            }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622010-SHDR-D010000001",
        "add_time": "2022-06-22 15:48:41",
        "platform_trade_id": "22062204140030001066",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "",
        "out_time": "",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622010-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691428937375",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-22 16:02:22",
                "psp_name": "ali"
            },
            {
                "transaction_id": "20220622010-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001480202206227616435440",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-22 16:02:23",
                "psp_name": "wechat"
            }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622009-SHDR-D010000001",
        "add_time": "2022-06-22 15:45:15",
        "platform_trade_id": "22062204140030001065",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "SUCCESS",
        "out_time": "2022-06-22 15:46:28",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622009-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691428799237",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-22 15:46:50",
                "psp_name": "ali"
            },
            {
                "transaction_id": "20220622009-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001482202206229712494406",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "",
                "refund_time": "",
                "psp_name": "wechat"
            }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622007-SHDR-D010000001",
        "add_time": "2022-06-22 15:13:10",
        "platform_trade_id": "22062204140030001060",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "FAIL",
        "out_time": "2022-06-22 15:13:58",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622007-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691428894157",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "AUTOREFUND",
                "refund_time": "2022-06-22 15:14:24",
                "psp_name": "ali"
            },
            {
                "transaction_id": "20220622007-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001514202206226862897599",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "AUTOREFUND",
                "refund_time": "2022-06-22 15:13:58",
                "psp_name": "wechat"
            }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622006-SHDR-D010000001",
        "add_time": "2022-06-22 14:57:46",
        "platform_trade_id": "22062204140030001057",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "FAIL",
        "out_time": "2022-06-22 15:10:14",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622006-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691427728717",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "AUTOREFUND",
                "refund_time": "2022-06-22 15:10:14",
                "psp_name": "ali"
            },
            {
                "transaction_id": "20220622006-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001492202206228236528307",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "AUTOREFUND",
                "refund_time": "2022-06-22 15:10:14",
                "psp_name": "wechat"
            }
        ]
    },
    {
        "goods_name": "测试纪念章1",
        "SKU": "G010000001",
        "channel": "0",
        "device_name": "",
        "device_code": "",
        "order_id": "20220622005-SHDR-D010000001",
        "add_time": "2022-06-22 14:48:27",
        "platform_trade_id": "22062204140030001056",
        "order_type": "SHDR",
        "order_pay_status": "DOUBLEPAY",
        "pay_time": "",
        "order_out_status": "SUCCESS",
        "out_time": "2022-06-22 14:50:27",
        "amount": "0.1",
        "discount": "0",
        "actual_collection": "0.1",
        "transaction_info": [
            {
                "transaction_id": "20220622005-SHDR-D010000001-WECHAT",
                "psp_order_id": "4200001509202206228685287134",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-22 14:50:47",
                "psp_name": "wechat"
            },
            {
                "transaction_id": "20220622005-SHDR-D010000001-ALI",
                "psp_order_id": "2022062222001432691428895498",
                "transaction_status": "SUCCESS",
                "finish_time": "",
                "refund_status": "MANUALREFUND",
                "refund_time": "2022-06-24 14:18:47",
                "psp_name": "ali"
            }
        ]
    },

]

export const storeList = [
    {
        "store_id": 1,
        "storeName": "宽窄巷子",
        "parent": 14,
        "parent_store_name": "中央红军长征出发纪念馆(纪念章)",
        "order_type": "工行",
        "device_count": 15,
        "city": "四川",
        "pay_name": "成都文旅宽窄巷子公司",
        "edit_date": "2023-09-18 14:07:08"
    },
    {
        "store_id": 9,
        "store_name": "支付宝测试",
        "parent": 15,
        "parent_store_name": "合肥科技馆(纪念章)",
        "order_type": "支付宝",
        "device_count": 2,
        "city": "上海",
        "pay_name": "远望谷支付宝",
        "edit_date": "2023-09-18 14:07:08"
    },
    {
        "store_id": 8,
        "store_name": "微信测试",
        "parent": 1,
        "parent_store_name": "宽窄巷子",
        "order_type": "微信",
        "device_count": 0,
        "city": "上海",
        "pay_name": "远望谷微信",
        "edit_date": "2023-09-18 11:02:23"
    },
    {
        "store_id": 30,
        "store_name": "北纬30°展示馆(纪念章)",
        "parent": 4,
        "parent_store_name": "铜官窑古镇",
        "order_type": "微信",
        "device_count": 0,
        "city": "北京",
        "pay_name": "南京红山一代机",
        "edit_date": "2023-09-18 09:04:55"
    },
    {
        "store_id": 15,
        "store_name": "合肥科技馆(纪念章)",
        "parent": 9,
        "parent_store_name": "支付宝测试",
        "order_type": "支付宝",
        "device_count": 0,
        "city": "北京",
        "pay_name": "远望谷支付宝",
        "edit_date": "2023-09-18 08:57:57"
    },
    {
        "store_id": 32,
        "store_name": "上海木文化博物馆(集章册)",
        "parent": 1,
        "parent_store_name": "宽窄巷子",
        "order_type": "支付宝",
        "device_count": 0,
        "city": "上海",
        "pay_name": "远望谷支付宝",
        "edit_date": "2023-09-15 20:57:09"
    },
    {
        "store_id": 31,
        "store_name": "黄花塘新四军军部纪念馆",
        "parent": 7,
        "parent_store_name": "南山茶海(纪念章)",
        "order_type": "微信",
        "device_count": 0,
        "city": "北京",
        "pay_name": "南京红山一代机",
        "edit_date": "2023-09-15 20:41:08"
    },
    {
        "store_id": 7,
        "store_name": "南山茶海(纪念章)",
        "parent": 1,
        "parent_store_name": "宽窄巷子",
        "order_type": "微信和支付宝",
        "device_count": 3,
        "city": "北京",
        "pay_name": "远望谷微信支付宝",
        "edit_date": "2023-09-15 19:19:44"
    }
]
export const deviceList = [
    {
        "deviceId": 1,
        "deviceName": "宽窄巷子"
    },
    {
        "deviceId": 9,
        "deviceName": "支付宝测试"
    },
    {
        "deviceId": 8,
        "deviceName": "微信测试"
    },
    {
        "deviceId": 30,
        "deviceName": "北纬30°展示馆(纪念章)"
    },
    {
        "deviceId": 15,
        "deviceName": "合肥科技馆(纪念章)"
    },
    {
        "deviceId": 32,
        "deviceName": "上海木文化博物馆(集章册)"
    },
    {
        "deviceId": 31,
        "deviceName": "黄花塘新四军军部纪念馆",
    },
    {
        "deviceId": 7,
        "deviceName": "南山茶海(纪念章)"
    }
]
export const tabledata = {
    deviceMapList: [
        { name: "浙江省博物馆（之江馆）7号设备1F", 工行: 0, 微信: 735, 总计: 980, 支付宝: 245, 银联: 0 },
        { name: "浙江省博物馆（之江馆）3号设备3F", 工行: 0, 微信: 665, 总计: 945, 支付宝: 280, 银联: 0 },
        { name: "东方明珠塔6号-263M", 工行: 0, 微信: 700, 总计: 730, 支付宝: 30, 银联: 0 },
        { name: "闵行博物馆2号", 工行: 0, 微信: 380, 总计: 720, 支付宝: 340, 银联: 0 },
        { name: "1号-宽窄巷子-听香", 工行: 608, 微信: 0, 总计: 608, 支付宝: 0, 银联: 0 },
        { name: "东方明珠塔1号-263M", 工行: 0, 微信: 550, 总计: 580, 支付宝: 30, 银联: 0 },
        { name: "闵行博物馆2号", 工行: 0, 微信: 380, 总计: 720, 支付宝: 340, 银联: 0 },
        { name: "1号-宽窄巷子-听香", 工行: 608, 微信: 0, 总计: 608, 支付宝: 0, 银联: 0 }
    ],
    payMapList: [
        { name: "工行", value: 1408 },
        { name: "支付宝", value: 1748 },
        { name: "银联", value: 718 },
        { name: "微信", value: 5579 }
    ],
    totalMapList: [
        { 工行: 1408, 微信: 5579, 总台数: 38, 总计: 9453, 支付宝: 1748, 银联: 718 }
    ]
}
export const optionPie = {
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
        top: '2%',
        left: 'center',
    },
    series: [
        {
            name: '支付信息',
            type: 'pie',
            radius: ['50%', '70%'],
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center',
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: '30',
                    fontWeight: 'bold',
                },
            },
            labelLine: {
                show: false,
            },
            data: [],
        },
    ],
}
export const allyearData = [
    {
        time: [new Date(new Date().getFullYear(), 0, 1), new Date()],
        data:
        {
            sales_Revenue: '265654000000',
            sales_Quantity: '156455554',
            scenic_Spot: '82244554',
            sku_Num: '7814265654',
            deviece_num: '124265654',
            single_unit_Sales: '789925654',
            refund_Amount: '124265654',
            refund_Rate: '1.5'
        }
    },
    {
        time: [new Date(new Date().getFullYear(), 0, 1) - 1, new Date()],
        data:
        {
            sales_Revenue: '26545400000',
            sales_Quantity: '153454554',
            scenic_Spot: '85244554',
            sku_Num: '7864265654',
            deviece_num: '124255654',
            single_unit_Sales: '719925654',
            refund_Amount: '184265654',
            refund_Rate: '1.9'
        }
    },
    {
        time: [new Date(new Date().getFullYear(), 0, 1) - 2, new Date()],
        data:
        {
            sales_Revenue: '24565400000',
            sales_Quantity: '146454554',
            scenic_Spot: '86244554',
            sku_Num: '721426654',
            deviece_num: '174265654',
            single_unit_Sales: '769925654',
            refund_Amount: '174265654',
            refund_Rate: '1.3'
        }
    }

]
export const Data = {
    "alldata": {
        deviceMapList: [],
        payMapList: [],
        totalMapList: []
    },
    "major_suit": {
        deviceMapList: [],
        payMapList: [],
        totalMapList: []
    },
    "commemorative_medal": {
        deviceMapList: [],
        payMapList: [],
        totalMapList: []
    },
    "refrigerator_sticker": {
        deviceMapList: [],
        payMapList: [],
        totalMapList: []
    }
}
export const yearchangeData = {
    time: [],
    data: {
        sales_Revenue: '115650000',
        sales_Quantity: '116455554',
        scenic_Spot: '11244554',
        sku_Num: '1114265654',
        deviece_num: '114265654',
        single_unit_Sales: '119925654',
        refund_Amount: '114265654',
        refund_Rate: '0.6'
    },
    ratio: {
        sales_Revenue: "0",
        sales_Quantity: "0",
        sales_Revenue: "0",
        scenic_Spot: "0",
        sku_Num: "0",
        deviece_num: "0",
        single_unit_Sales: "0",
        refund_Amount: "0",
        refund_Rate: "0",
    }
}
